import { GameStore } from '../../../store/GameStore';
import { recentResultDetailStateActions } from '../../../store/slices/recentResultDetail/slice';

export const openHashModel = (
  index: number,
  tab: string,
  multiplier: number,
  hashKey: string,
  encryptedResult: string,
  betTime: string,
): void => {

  GameStore.dispatch(recentResultDetailStateActions.setModalOpen(true));
  GameStore.dispatch(recentResultDetailStateActions.setHashModalData({index: index, clickedTab: tab}));
  GameStore.dispatch(recentResultDetailStateActions.setResultMultiplier(multiplier));
  GameStore.dispatch(recentResultDetailStateActions.setHashKey(hashKey));
  GameStore.dispatch(recentResultDetailStateActions.setHashResult(encryptedResult));
  GameStore.dispatch(recentResultDetailStateActions.setTimeStamp(betTime));
}